import api from '../utils/baseUrl';

class PartnerService {
    async getBestPartners(filters: {
        userType?: string;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get('/api/partners/best', {params: filters});
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching best partners:', error);
            return [];
        }
    }

    async getPartner(partnerId: string) {
        try {
            const response = await api.get(`/api/partners/${partnerId}`);
            return response.data ?? {};
        } catch (error) {
            console.error('Error fetching promoter data:', error);
            return [];
        }
    }

    async getPartnerCampaignLinks(partnerId: string, filters: {
        isActive?: boolean;
        search?: string;
        sortBy?: string;
        sortDirection?: 'asc' | 'desc';
    } = {}) {
        try {
            const response = await api.get(`api/partners/${partnerId}/campaignLinks`, {params: filters});
            return Array.isArray(response.data.campaignLinks) ? response.data.campaignLinks : [];
        } catch (error) {
            console.error('Error fetching campaign links:', error);
            return [];
        }
    }

    async becomePartner() {
        return await api.post('/api/partners/become');
    }

    async upgradeToPartner() {
        return await api.post('/api/partners/upgrade');
    }

    async inviteUsers() {
        return await api.post('/api/partners/invite');
    }
}

export default new PartnerService();